import script from "./SignView.vue?vue&type=script&setup=true&lang=js"
export * from "./SignView.vue?vue&type=script&setup=true&lang=js"

import "./SignView.vue?vue&type=style&index=0&id=55c5ae30&lang=css"

const __exports__ = script;

export default __exports__